import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cc27814"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "image-dialog"
}

import { withDefaults, ref, computed } from "vue";
import { ImageMessageTypeEnum } from "@/clinic/typings/enums/direct-message";
import ImageDialog from "../../dialog/image.vue";
import { get, createReusableTemplate } from "@vueuse/core";
import { ILineEmoji } from "@/clinic/typings";
import { LineStickerServices, LineEmojiServices } from "@/clinic/services";

type IContentMessage = {
  id?: number;
  type: string;
  content?: string;
  emoji?: ILineEmoji;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'image',
  props: {
    id: null,
    type: { default: ImageMessageTypeEnum.image },
    content: { default: "" },
    emoji: null
  },
  setup(__props: any) {

const props = __props as { id?: number, type: string, content: string, emoji?: ILineEmoji };

const [DefineImage, ReuseImage] = createReusableTemplate();



const boxImageDialog = ref<HTMLElement>();

const stickerContent = computed((): string => LineStickerServices.getStickerUrl({ sticker_id: props.content }));

const emojiContent = computed((): string => {
  if (!props?.emoji) return "";

  const { productId: product_id, emojiId: emoji_id } = props.emoji;
  return LineEmojiServices.getEmojiUrl({ emoji_id, product_id });
});

const imageContent = computed((): string => {
  switch (props.type) {
    case ImageMessageTypeEnum.sticker:
      return get(stickerContent);
    case ImageMessageTypeEnum.emoji:
      return get(emojiContent);
    default:
      return props?.content;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DefineImage), null, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          role: "presentation",
          alt: "image",
          src: _unref(imageContent),
          class: _normalizeClass({ 'h-1.5rem w-1.5rem emoji small': __props.type == _unref(ImageMessageTypeEnum).emoji })
        }, null, 10, _hoisted_1)
      ]),
      _: 1
    }),
    (__props.type == _unref(ImageMessageTypeEnum).image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(get)(boxImageDialog.value)?.onShow()))
          }, [
            _createVNode(_unref(ReuseImage))
          ]),
          _createVNode(ImageDialog, {
            ref_key: "boxImageDialog",
            ref: boxImageDialog,
            id: __props.id
          }, null, 8, ["id"])
        ]))
      : (_openBlock(), _createBlock(_unref(ReuseImage), { key: 1 }))
  ], 64))
}
}

})